module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAAc0lEQVR42u3aQQ0AMAgEQexUQv3rQcP1VRU3JGtgfgQmyTQ3AAAAAAAAAAAAAACUA+y5aQoAAAAAAAAAAAAAAAAAfm0DAAAAAAAAAAAAAAAAALZBAAAAAAAAAAAAAAAAAKg9jfkUBQAAAAAAAAAAAACgpwdatIg7fTTeGQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/Austria.png
// module id = lHKN
// module chunks = 0 62 63